import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import CategorySection from './components/CategorySection';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';
import { siteInfo } from '@/mocks/siteInfo';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="凪光在线 - 官方入口与完整使用指南 | 流畅稳定的在线体验"
        description={siteInfo.description}
        canonicalUrl="https://naguflow.github.io"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '凪光在线首页',
            description: siteInfo.description,
            url: 'https://naguflow.github.io',
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '凪光在线是什么？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '凪光在线是一个值得信赖的在线服务平台，提供流畅稳定的在线体验。平台汇集了丰富的功能模块，满足个人和企业用户多样化的在线服务需求。',
                },
              },
              {
                '@type': 'Question',
                name: '如何注册凪光在线账号？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '访问凪光在线官网，点击右上角「注册」按钮，输入手机号码获取验证码，设置密码后即可完成注册。',
                },
              },
              {
                '@type': 'Question',
                name: '凪光在线是否免费使用？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '凪光在线提供基础版免费使用，涵盖大部分核心功能。同时提供高级版和企业版付费方案。',
                },
              },
              {
                '@type': 'Question',
                name: '如何在手机上使用凪光在线？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过手机浏览器访问凪光在线移动网页版，或下载官方APP。移动端与PC端数据实时同步。',
                },
              },
              {
                '@type': 'Question',
                name: '忘记了登录密码怎么办？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '在登录页面点击「忘记密码」，输入注册时绑定的手机号或邮箱，系统会发送验证码。验证身份后即可设置新密码。',
                },
              },
            ],
          },
        ]}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeatureSection />
        <CategorySection />
        <LatestArticles />
        <FAQSection />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}